import { FlexBox } from '@brg/ui';
import React, { useEffect, useMemo } from 'react';
import { ModalButton, ModalClose, ModalDescription, NotSavedContentWrapper, ModalName, NotSavedModalWrapper } from './CardSelectModal/styles';
import useLocalization from '../../hooks/useLocalization';
import CloseIcon from '../icons/CloseIcon';
var ADDITIONAL_PERCENT_FOR_CENTERING = 23;
export var NotSavedImagesModal = function (_a) {
    var onClick = _a.onClick, prevStyle = _a.prevStyle, height = _a.height, scroll = _a.scroll;
    var t = useLocalization().t;
    var scrollPercent = useMemo(function () {
        if (height && scroll) {
            var percent = ((scroll * 100) / height);
            return percent > 30
                ? (percent).toFixed()
                : percent === 0
                    ? ADDITIONAL_PERCENT_FOR_CENTERING
                    : (percent).toFixed();
        }
    }, [height, scroll]);
    return (React.createElement(NotSavedModalWrapper, null,
        React.createElement(NotSavedContentWrapper, { pos: scrollPercent },
            React.createElement(FlexBox, { direction: 'column', directionMobile: 'column', align: 'center', alignMobile: 'center' },
                React.createElement(ModalClose, { justify: 'flex-end', justifyMobile: 'flex-end', align: 'flex-start', alignMobile: 'flex-start', width: '100%', widthMobile: '100%' },
                    React.createElement(CloseIcon, { onClick: function () { return onClick(true, prevStyle); } })),
                React.createElement(ModalName, { offsetBottom: 16, offsetBottomMobile: 16 }, t('modal.unsaved.header')),
                React.createElement(ModalDescription, null, t('modal.unsaved.description')),
                React.createElement(FlexBox, { direction: 'row', directionMobile: 'row', gx: 17, gxMobile: 17, offsetTop: 32, offsetTopMobile: 32 },
                    React.createElement(ModalButton, { onClick: function () { return onClick(false); } }, t('modal.unsaved.aggree')),
                    React.createElement(ModalButton, { width: 152, onClick: function () { return onClick(true, prevStyle); }, fill: '#151514' }, t('modal.unsaved.cancel')))))));
};
//# sourceMappingURL=NotSavedImagesModal.js.mapimport { FlexBox } from '@brg/ui';
import React, { useEffect, useMemo } from 'react';
import { ModalButton, ModalClose, ModalDescription, NotSavedContentWrapper, ModalName, NotSavedModalWrapper } from './CardSelectModal/styles';
import useLocalization from '../../hooks/useLocalization';
import CloseIcon from '../icons/CloseIcon';
var ADDITIONAL_PERCENT_FOR_CENTERING = 23;
export var NotSavedImagesModal = function (_a) {
    var onClick = _a.onClick, prevStyle = _a.prevStyle, height = _a.height, scroll = _a.scroll;
    var t = useLocalization().t;
    var scrollPercent = useMemo(function () {
        if (height && scroll) {
            var percent = ((scroll * 100) / height);
            return percent > 30
                ? (percent).toFixed()
                : percent === 0
                    ? ADDITIONAL_PERCENT_FOR_CENTERING
                    : (percent).toFixed();
        }
    }, [height, scroll]);
    return (React.createElement(NotSavedModalWrapper, null,
        React.createElement(NotSavedContentWrapper, { pos: scrollPercent },
            React.createElement(FlexBox, { direction: 'column', directionMobile: 'column', align: 'center', alignMobile: 'center' },
                React.createElement(ModalClose, { justify: 'flex-end', justifyMobile: 'flex-end', align: 'flex-start', alignMobile: 'flex-start', width: '100%', widthMobile: '100%' },
                    React.createElement(CloseIcon, { onClick: function () { return onClick(true, prevStyle); } })),
                React.createElement(ModalName, { offsetBottom: 16, offsetBottomMobile: 16 }, t('modal.unsaved.header')),
                React.createElement(ModalDescription, null, t('modal.unsaved.description')),
                React.createElement(FlexBox, { direction: 'row', directionMobile: 'row', gx: 17, gxMobile: 17, offsetTop: 32, offsetTopMobile: 32 },
                    React.createElement(ModalButton, { onClick: function () { return onClick(false); } }, t('modal.unsaved.aggree')),
                    React.createElement(ModalButton, { width: 152, onClick: function () { return onClick(true, prevStyle); }, fill: '#151514' }, t('modal.unsaved.cancel')))))));
};
//# sourceMappingURL=NotSavedImagesModal.js.map